
import './style.less'

import { h, Fragment } from 'preact'
import { useState } from 'preact/hooks'
import { withHydration } from '@util/hydrate'


const svgWidth = 1210
const svgHeight = 602


const HoverLocation = ({ x, y, title, subtitle }) => {
	return (
		<>
			{/* dot */}
			<rect x={x} y={y} width="5" height="5" rx="2.5" />
			{/* hover area */}
			<rect x={x - 8} y={y - 8} width="21" height="21" rx="21" class="globe__hover" data-title={title} data-subtitle={subtitle} />
		</>
	)
}


export const Globe = () => (
	<div class="globe">
		<svg class="globe__svg" width={svgWidth} height={svgHeight} viewBox="0 0 1210 602" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g fill="white">
				<HoverLocation x="271" y="208"/>
				<HoverLocation x="303" y="192"/>
				<HoverLocation x="271" y="176"/>
				<HoverLocation x="287" y="176"/>
				<HoverLocation x="591" y="176" title="France" subtitle="Epoka"/>
				<HoverLocation x="623" y="176" title="Germany" subtitle="Grapevine"/>
				<HoverLocation x="623" y="208" title="Italy" subtitle="Grapevine"/>
				<HoverLocation x="639" y="160" title="Poland" subtitle="MJCC"/>
				<HoverLocation x="575" y="144" title="United Kingdom" subtitle="Blackbridge"/>
				<HoverLocation x="607" y="144" title="Netherlands" subtitle="Steam"/>
				<HoverLocation x="623" y="144" title="Denmark" subtitle="core:workers"/>
				<HoverLocation x="671" y="144" title="Russia" subtitle="FutureToday"/>
				<HoverLocation x="639" y="128" title="Sweden" subtitle="core:workers"/>
				<HoverLocation x="863" y="272"/>
				<HoverLocation x="975" y="272"/>
				<HoverLocation x="303" y="256"/>
				<HoverLocation x="991" y="240"/>
				<HoverLocation x="943" y="368"/>
				<HoverLocation x="1103" y="496"/>
				<HoverLocation x="431" y="464"/>
				<HoverLocation x="1103" y="464"/>
			</g>
			<g opacity="0.2" fill="white">
				<rect x="0" y="96" width="5" height="5" rx="2.5"/>
				<rect x="15" y="96" width="5" height="5" rx="2.5"/>
				<rect x="15" y="80" width="5" height="5" rx="2.5"/>
				<rect x="31" y="96" width="5" height="5" rx="2.5"/>
				<rect x="31" y="80" width="5" height="5" rx="2.5"/>
				<rect x="47" y="96" width="5" height="5" rx="2.5"/>
				<rect x="47" y="80" width="5" height="5" rx="2.5"/>
				<rect x="63" y="96" width="5" height="5" rx="2.5"/>
				<rect x="63" y="80" width="5" height="5" rx="2.5"/>
				<rect x="79" y="96" width="5" height="5" rx="2.5"/>
				<rect x="79" y="80" width="5" height="5" rx="2.5"/>
				<rect x="95" y="96" width="5" height="5" rx="2.5"/>
				<rect x="95" y="80" width="5" height="5" rx="2.5"/>
				<rect x="111" y="96" width="5" height="5" rx="2.5"/>
				<rect x="111" y="80" width="5" height="5" rx="2.5"/>
				<rect x="127" y="96" width="5" height="5" rx="2.5"/>
				<rect x="127" y="80" width="5" height="5" rx="2.5"/>
				<rect x="143" y="96" width="5" height="5" rx="2.5"/>
				<rect x="143" y="80" width="5" height="5" rx="2.5"/>
				<rect x="159" y="96" width="5" height="5" rx="2.5"/>
				<rect x="159" y="208" width="5" height="5" rx="2.5"/>
				<rect x="159" y="80" width="5" height="5" rx="2.5"/>
				<rect x="159" y="192" width="5" height="5" rx="2.5"/>
				<rect x="175" y="96" width="5" height="5" rx="2.5"/>
				<rect x="175" y="208" width="5" height="5" rx="2.5"/>
				<rect x="175" y="80" width="5" height="5" rx="2.5"/>
				<rect x="175" y="192" width="5" height="5" rx="2.5"/>
				<rect x="191" y="96" width="5" height="5" rx="2.5"/>
				<rect x="191" y="208" width="5" height="5" rx="2.5"/>
				<rect x="191" y="80" width="5" height="5" rx="2.5"/>
				<rect x="191" y="192" width="5" height="5" rx="2.5"/>
				<rect x="207" y="96" width="5" height="5" rx="2.5"/>
				<rect x="207" y="208" width="5" height="5" rx="2.5"/>
				<rect x="207" y="80" width="5" height="5" rx="2.5"/>
				<rect x="207" y="192" width="5" height="5" rx="2.5"/>
				<rect x="223" y="96" width="5" height="5" rx="2.5"/>
				<rect x="223" y="208" width="5" height="5" rx="2.5"/>
				<rect x="223" y="80" width="5" height="5" rx="2.5"/>
				<rect x="223" y="192" width="5" height="5" rx="2.5"/>
				<rect x="239" y="96" width="5" height="5" rx="2.5"/>
				<rect x="239" y="208" width="5" height="5" rx="2.5"/>
				<rect x="239" y="80" width="5" height="5" rx="2.5"/>
				<rect x="239" y="192" width="5" height="5" rx="2.5"/>
				<rect x="255" y="96" width="5" height="5" rx="2.5"/>
				<rect x="255" y="208" width="5" height="5" rx="2.5"/>
				<rect x="255" y="192" width="5" height="5" rx="2.5"/>
				<rect x="271" y="96" width="5" height="5" rx="2.5"/>
				<rect x="271" y="80" width="5" height="5" rx="2.5"/>
				<rect x="271" y="192" width="5" height="5" rx="2.5"/>
				<rect x="287" y="96" width="5" height="5" rx="2.5"/>
				<rect x="287" y="208" width="5" height="5" rx="2.5"/>
				<rect x="287" y="80" width="5" height="5" rx="2.5"/>
				<rect x="287" y="192" width="5" height="5" rx="2.5"/>
				<rect x="303" y="96" width="5" height="5" rx="2.5"/>
				<rect x="303" y="208" width="5" height="5" rx="2.5"/>
				<rect x="303" y="80" width="5" height="5" rx="2.5"/>
				<rect x="319" y="96" width="5" height="5" rx="2.5"/>
				<rect x="319" y="208" width="5" height="5" rx="2.5"/>
				<rect x="319" y="80" width="5" height="5" rx="2.5"/>
				<rect x="319" y="192" width="5" height="5" rx="2.5"/>
				<rect x="335" y="96" width="5" height="5" rx="2.5"/>
				<rect x="335" y="80" width="5" height="5" rx="2.5"/>
				<rect x="335" y="192" width="5" height="5" rx="2.5"/>
				<rect x="351" y="96" width="5" height="5" rx="2.5"/>
				<rect x="367" y="96" width="5" height="5" rx="2.5"/>
				<rect x="399" y="96" width="5" height="5" rx="2.5"/>
				<rect x="399" y="80" width="5" height="5" rx="2.5"/>
				<rect x="415" y="96" width="5" height="5" rx="2.5"/>
				<rect x="415" y="80" width="5" height="5" rx="2.5"/>
				<rect x="431" y="96" width="5" height="5" rx="2.5"/>
				<rect x="431" y="80" width="5" height="5" rx="2.5"/>
				<rect x="447" y="80" width="5" height="5" rx="2.5"/>
				<rect x="463" y="80" width="5" height="5" rx="2.5"/>
				<rect x="479" y="80" width="5" height="5" rx="2.5"/>
				<rect x="511" y="96" width="5" height="5" rx="2.5"/>
				<rect x="527" y="96" width="5" height="5" rx="2.5"/>
				<rect x="559" y="208" width="5" height="5" rx="2.5"/>
				<rect x="559" y="192" width="5" height="5" rx="2.5"/>
				<rect x="575" y="208" width="5" height="5" rx="2.5"/>
				<rect x="575" y="192" width="5" height="5" rx="2.5"/>
				<rect x="591" y="192" width="5" height="5" rx="2.5"/>
				<rect x="607" y="192" width="5" height="5" rx="2.5"/>
				<rect x="623" y="96" width="5" height="5" rx="2.5"/>
				<rect x="623" y="192" width="5" height="5" rx="2.5"/>
				<rect x="639" y="96" width="5" height="5" rx="2.5"/>
				<rect x="639" y="80" width="5" height="5" rx="2.5"/>
				<rect x="639" y="192" width="5" height="5" rx="2.5"/>
				<rect x="655" y="96" width="5" height="5" rx="2.5"/>
				<rect x="655" y="208" width="5" height="5" rx="2.5"/>
				<rect x="655" y="80" width="5" height="5" rx="2.5"/>
				<rect x="655" y="192" width="5" height="5" rx="2.5"/>
				<rect x="671" y="96" width="5" height="5" rx="2.5"/>
				<rect x="671" y="208" width="5" height="5" rx="2.5"/>
				<rect x="671" y="80" width="5" height="5" rx="2.5"/>
				<rect x="671" y="192" width="5" height="5" rx="2.5"/>
				<rect x="687" y="96" width="5" height="5" rx="2.5"/>
				<rect x="687" y="208" width="5" height="5" rx="2.5"/>
				<rect x="687" y="80" width="5" height="5" rx="2.5"/>
				<rect x="703" y="96" width="5" height="5" rx="2.5"/>
				<rect x="703" y="208" width="5" height="5" rx="2.5"/>
				<rect x="703" y="80" width="5" height="5" rx="2.5"/>
				<rect x="719" y="96" width="5" height="5" rx="2.5"/>
				<rect x="719" y="208" width="5" height="5" rx="2.5"/>
				<rect x="735" y="96" width="5" height="5" rx="2.5"/>
				<rect x="735" y="208" width="5" height="5" rx="2.5"/>
				<rect x="735" y="192" width="5" height="5" rx="2.5"/>
				<rect x="751" y="96" width="5" height="5" rx="2.5"/>
				<rect x="751" y="208" width="5" height="5" rx="2.5"/>
				<rect x="767" y="96" width="5" height="5" rx="2.5"/>
				<rect x="767" y="80" width="5" height="5" rx="2.5"/>
				<rect x="767" y="192" width="5" height="5" rx="2.5"/>
				<rect x="783" y="96" width="5" height="5" rx="2.5"/>
				<rect x="783" y="208" width="5" height="5" rx="2.5"/>
				<rect x="783" y="192" width="5" height="5" rx="2.5"/>
				<rect x="799" y="96" width="5" height="5" rx="2.5"/>
				<rect x="799" y="208" width="5" height="5" rx="2.5"/>
				<rect x="799" y="80" width="5" height="5" rx="2.5"/>
				<rect x="799" y="192" width="5" height="5" rx="2.5"/>
				<rect x="815" y="96" width="5" height="5" rx="2.5"/>
				<rect x="815" y="208" width="5" height="5" rx="2.5"/>
				<rect x="815" y="80" width="5" height="5" rx="2.5"/>
				<rect x="815" y="192" width="5" height="5" rx="2.5"/>
				<rect x="831" y="96" width="5" height="5" rx="2.5"/>
				<rect x="831" y="208" width="5" height="5" rx="2.5"/>
				<rect x="831" y="80" width="5" height="5" rx="2.5"/>
				<rect x="831" y="192" width="5" height="5" rx="2.5"/>
				<rect x="847" y="96" width="5" height="5" rx="2.5"/>
				<rect x="847" y="208" width="5" height="5" rx="2.5"/>
				<rect x="847" y="192" width="5" height="5" rx="2.5"/>
				<rect x="863" y="96" width="5" height="5" rx="2.5"/>
				<rect x="863" y="208" width="5" height="5" rx="2.5"/>
				<rect x="863" y="80" width="5" height="5" rx="2.5"/>
				<rect x="863" y="192" width="5" height="5" rx="2.5"/>
				<rect x="879" y="96" width="5" height="5" rx="2.5"/>
				<rect x="879" y="208" width="5" height="5" rx="2.5"/>
				<rect x="879" y="80" width="5" height="5" rx="2.5"/>
				<rect x="879" y="192" width="5" height="5" rx="2.5"/>
				<rect x="895" y="96" width="5" height="5" rx="2.5"/>
				<rect x="895" y="208" width="5" height="5" rx="2.5"/>
				<rect x="895" y="80" width="5" height="5" rx="2.5"/>
				<rect x="895" y="192" width="5" height="5" rx="2.5"/>
				<rect x="911" y="96" width="5" height="5" rx="2.5"/>
				<rect x="911" y="208" width="5" height="5" rx="2.5"/>
				<rect x="911" y="80" width="5" height="5" rx="2.5"/>
				<rect x="911" y="192" width="5" height="5" rx="2.5"/>
				<rect x="927" y="96" width="5" height="5" rx="2.5"/>
				<rect x="927" y="208" width="5" height="5" rx="2.5"/>
				<rect x="927" y="80" width="5" height="5" rx="2.5"/>
				<rect x="927" y="192" width="5" height="5" rx="2.5"/>
				<rect x="943" y="96" width="5" height="5" rx="2.5"/>
				<rect x="943" y="208" width="5" height="5" rx="2.5"/>
				<rect x="943" y="80" width="5" height="5" rx="2.5"/>
				<rect x="943" y="192" width="5" height="5" rx="2.5"/>
				<rect x="959" y="96" width="5" height="5" rx="2.5"/>
				<rect x="959" y="208" width="5" height="5" rx="2.5"/>
				<rect x="959" y="80" width="5" height="5" rx="2.5"/>
				<rect x="959" y="192" width="5" height="5" rx="2.5"/>
				<rect x="975" y="96" width="5" height="5" rx="2.5"/>
				<rect x="975" y="208" width="5" height="5" rx="2.5"/>
				<rect x="975" y="80" width="5" height="5" rx="2.5"/>
				<rect x="975" y="192" width="5" height="5" rx="2.5"/>
				<rect x="991" y="96" width="5" height="5" rx="2.5"/>
				<rect x="991" y="208" width="5" height="5" rx="2.5"/>
				<rect x="991" y="80" width="5" height="5" rx="2.5"/>
				<rect x="991" y="192" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="192" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="208" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="192" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="192" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="208" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="192" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1103" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1103" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1119" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1119" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1135" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1135" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1151" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1151" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1167" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1167" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1183" y="96" width="5" height="5" rx="2.5"/>
				<rect x="1183" y="80" width="5" height="5" rx="2.5"/>
				<rect x="1199" y="96" width="5" height="5" rx="2.5"/>
				<rect x="159" y="64" width="5" height="5" rx="2.5"/>
				<rect x="159" y="176" width="5" height="5" rx="2.5"/>
				<rect x="175" y="64" width="5" height="5" rx="2.5"/>
				<rect x="175" y="176" width="5" height="5" rx="2.5"/>
				<rect x="191" y="64" width="5" height="5" rx="2.5"/>
				<rect x="191" y="176" width="5" height="5" rx="2.5"/>
				<rect x="207" y="64" width="5" height="5" rx="2.5"/>
				<rect x="207" y="176" width="5" height="5" rx="2.5"/>
				<rect x="223" y="64" width="5" height="5" rx="2.5"/>
				<rect x="223" y="176" width="5" height="5" rx="2.5"/>
				<rect x="239" y="64" width="5" height="5" rx="2.5"/>
				<rect x="239" y="176" width="5" height="5" rx="2.5"/>
				<rect x="255" y="64" width="5" height="5" rx="2.5"/>
				<rect x="255" y="176" width="5" height="5" rx="2.5"/>
				<rect x="271" y="64" width="5" height="5" rx="2.5"/>
				<rect x="287" y="64" width="5" height="5" rx="2.5"/>
				<rect x="303" y="64" width="5" height="5" rx="2.5"/>
				<rect x="303" y="176" width="5" height="5" rx="2.5"/>
				<rect x="319" y="64" width="5" height="5" rx="2.5"/>
				<rect x="319" y="176" width="5" height="5" rx="2.5"/>
				<rect x="335" y="176" width="5" height="5" rx="2.5"/>
				<rect x="351" y="176" width="5" height="5" rx="2.5"/>
				<rect x="367" y="176" width="5" height="5" rx="2.5"/>
				<rect x="383" y="64" width="5" height="5" rx="2.5"/>
				<rect x="399" y="64" width="5" height="5" rx="2.5"/>
				<rect x="415" y="64" width="5" height="5" rx="2.5"/>
				<rect x="431" y="64" width="5" height="5" rx="2.5"/>
				<rect x="447" y="64" width="5" height="5" rx="2.5"/>
				<rect x="463" y="64" width="5" height="5" rx="2.5"/>
				<rect x="479" y="64" width="5" height="5" rx="2.5"/>
				<rect x="495" y="64" width="5" height="5" rx="2.5"/>
				<rect x="575" y="176" width="5" height="5" rx="2.5"/>
				<rect x="607" y="176" width="5" height="5" rx="2.5"/>
				<rect x="639" y="176" width="5" height="5" rx="2.5"/>
				<rect x="655" y="176" width="5" height="5" rx="2.5"/>
				<rect x="671" y="176" width="5" height="5" rx="2.5"/>
				<rect x="687" y="176" width="5" height="5" rx="2.5"/>
				<rect x="703" y="176" width="5" height="5" rx="2.5"/>
				<rect x="719" y="176" width="5" height="5" rx="2.5"/>
				<rect x="735" y="176" width="5" height="5" rx="2.5"/>
				<rect x="767" y="64" width="5" height="5" rx="2.5"/>
				<rect x="767" y="176" width="5" height="5" rx="2.5"/>
				<rect x="783" y="64" width="5" height="5" rx="2.5"/>
				<rect x="783" y="176" width="5" height="5" rx="2.5"/>
				<rect x="799" y="176" width="5" height="5" rx="2.5"/>
				<rect x="815" y="176" width="5" height="5" rx="2.5"/>
				<rect x="831" y="176" width="5" height="5" rx="2.5"/>
				<rect x="847" y="176" width="5" height="5" rx="2.5"/>
				<rect x="863" y="176" width="5" height="5" rx="2.5"/>
				<rect x="879" y="64" width="5" height="5" rx="2.5"/>
				<rect x="879" y="176" width="5" height="5" rx="2.5"/>
				<rect x="895" y="64" width="5" height="5" rx="2.5"/>
				<rect x="895" y="176" width="5" height="5" rx="2.5"/>
				<rect x="911" y="64" width="5" height="5" rx="2.5"/>
				<rect x="911" y="176" width="5" height="5" rx="2.5"/>
				<rect x="927" y="64" width="5" height="5" rx="2.5"/>
				<rect x="927" y="176" width="5" height="5" rx="2.5"/>
				<rect x="943" y="64" width="5" height="5" rx="2.5"/>
				<rect x="943" y="176" width="5" height="5" rx="2.5"/>
				<rect x="959" y="64" width="5" height="5" rx="2.5"/>
				<rect x="959" y="176" width="5" height="5" rx="2.5"/>
				<rect x="975" y="64" width="5" height="5" rx="2.5"/>
				<rect x="975" y="176" width="5" height="5" rx="2.5"/>
				<rect x="991" y="176" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="64" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="176" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="64" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="176" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="176" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="176" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="64" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="176" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="64" width="5" height="5" rx="2.5"/>
				<rect x="143" y="160" width="5" height="5" rx="2.5"/>
				<rect x="159" y="160" width="5" height="5" rx="2.5"/>
				<rect x="175" y="48" width="5" height="5" rx="2.5"/>
				<rect x="175" y="160" width="5" height="5" rx="2.5"/>
				<rect x="191" y="48" width="5" height="5" rx="2.5"/>
				<rect x="191" y="160" width="5" height="5" rx="2.5"/>
				<rect x="207" y="48" width="5" height="5" rx="2.5"/>
				<rect x="207" y="160" width="5" height="5" rx="2.5"/>
				<rect x="223" y="48" width="5" height="5" rx="2.5"/>
				<rect x="223" y="160" width="5" height="5" rx="2.5"/>
				<rect x="239" y="48" width="5" height="5" rx="2.5"/>
				<rect x="239" y="160" width="5" height="5" rx="2.5"/>
				<rect x="255" y="48" width="5" height="5" rx="2.5"/>
				<rect x="255" y="160" width="5" height="5" rx="2.5"/>
				<rect x="271" y="160" width="5" height="5" rx="2.5"/>
				<rect x="287" y="160" width="5" height="5" rx="2.5"/>
				<rect x="303" y="160" width="5" height="5" rx="2.5"/>
				<rect x="319" y="160" width="5" height="5" rx="2.5"/>
				<rect x="335" y="160" width="5" height="5" rx="2.5"/>
				<rect x="351" y="48" width="5" height="5" rx="2.5"/>
				<rect x="351" y="160" width="5" height="5" rx="2.5"/>
				<rect x="367" y="48" width="5" height="5" rx="2.5"/>
				<rect x="383" y="48" width="5" height="5" rx="2.5"/>
				<rect x="399" y="48" width="5" height="5" rx="2.5"/>
				<rect x="415" y="48" width="5" height="5" rx="2.5"/>
				<rect x="431" y="48" width="5" height="5" rx="2.5"/>
				<rect x="447" y="48" width="5" height="5" rx="2.5"/>
				<rect x="463" y="48" width="5" height="5" rx="2.5"/>
				<rect x="479" y="48" width="5" height="5" rx="2.5"/>
				<rect x="495" y="48" width="5" height="5" rx="2.5"/>
				<rect x="559" y="160" width="5" height="5" rx="2.5"/>
				<rect x="591" y="160" width="5" height="5" rx="2.5"/>
				<rect x="607" y="160" width="5" height="5" rx="2.5"/>
				<rect x="623" y="160" width="5" height="5" rx="2.5"/>
				<rect x="655" y="160" width="5" height="5" rx="2.5"/>
				<rect x="671" y="160" width="5" height="5" rx="2.5"/>
				<rect x="687" y="160" width="5" height="5" rx="2.5"/>
				<rect x="703" y="160" width="5" height="5" rx="2.5"/>
				<rect x="719" y="160" width="5" height="5" rx="2.5"/>
				<rect x="735" y="160" width="5" height="5" rx="2.5"/>
				<rect x="751" y="160" width="5" height="5" rx="2.5"/>
				<rect x="767" y="160" width="5" height="5" rx="2.5"/>
				<rect x="783" y="160" width="5" height="5" rx="2.5"/>
				<rect x="799" y="48" width="5" height="5" rx="2.5"/>
				<rect x="799" y="160" width="5" height="5" rx="2.5"/>
				<rect x="815" y="48" width="5" height="5" rx="2.5"/>
				<rect x="815" y="160" width="5" height="5" rx="2.5"/>
				<rect x="831" y="160" width="5" height="5" rx="2.5"/>
				<rect x="847" y="160" width="5" height="5" rx="2.5"/>
				<rect x="863" y="160" width="5" height="5" rx="2.5"/>
				<rect x="879" y="160" width="5" height="5" rx="2.5"/>
				<rect x="895" y="160" width="5" height="5" rx="2.5"/>
				<rect x="911" y="160" width="5" height="5" rx="2.5"/>
				<rect x="927" y="160" width="5" height="5" rx="2.5"/>
				<rect x="943" y="48" width="5" height="5" rx="2.5"/>
				<rect x="943" y="160" width="5" height="5" rx="2.5"/>
				<rect x="959" y="160" width="5" height="5" rx="2.5"/>
				<rect x="975" y="160" width="5" height="5" rx="2.5"/>
				<rect x="991" y="160" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="160" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="160" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="160" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="160" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="160" width="5" height="5" rx="2.5"/>
				<rect y="144" width="5" height="5" rx="2.5"/>
				<rect x="15" y="144" width="5" height="5" rx="2.5"/>
				<rect x="143" y="144" width="5" height="5" rx="2.5"/>
				<rect x="159" y="144" width="5" height="5" rx="2.5"/>
				<rect x="175" y="144" width="5" height="5" rx="2.5"/>
				<rect x="191" y="144" width="5" height="5" rx="2.5"/>
				<rect x="207" y="144" width="5" height="5" rx="2.5"/>
				<rect x="223" y="144" width="5" height="5" rx="2.5"/>
				<rect x="239" y="144" width="5" height="5" rx="2.5"/>
				<rect x="255" y="144" width="5" height="5" rx="2.5"/>
				<rect x="271" y="144" width="5" height="5" rx="2.5"/>
				<rect x="287" y="144" width="5" height="5" rx="2.5"/>
				<rect x="319" y="144" width="5" height="5" rx="2.5"/>
				<rect x="335" y="144" width="5" height="5" rx="2.5"/>
				<rect x="351" y="144" width="5" height="5" rx="2.5"/>
				<rect x="367" y="32" width="5" height="5" rx="2.5"/>
				<rect x="367" y="144" width="5" height="5" rx="2.5"/>
				<rect x="383" y="32" width="5" height="5" rx="2.5"/>
				<rect x="383" y="144" width="5" height="5" rx="2.5"/>
				<rect x="399" y="32" width="5" height="5" rx="2.5"/>
				<rect x="415" y="32" width="5" height="5" rx="2.5"/>
				<rect x="431" y="32" width="5" height="5" rx="2.5"/>
				<rect x="447" y="32" width="5" height="5" rx="2.5"/>
				<rect x="463" y="32" width="5" height="5" rx="2.5"/>
				<rect x="479" y="32" width="5" height="5" rx="2.5"/>
				<rect x="495" y="32" width="5" height="5" rx="2.5"/>
				<rect x="511" y="32" width="5" height="5" rx="2.5"/>
				<rect x="559" y="144" width="5" height="5" rx="2.5"/>
				<rect x="639" y="144" width="5" height="5" rx="2.5"/>
				<rect x="655" y="144" width="5" height="5" rx="2.5"/>
				<rect x="687" y="144" width="5" height="5" rx="2.5"/>
				<rect x="703" y="144" width="5" height="5" rx="2.5"/>
				<rect x="719" y="144" width="5" height="5" rx="2.5"/>
				<rect x="735" y="144" width="5" height="5" rx="2.5"/>
				<rect x="751" y="144" width="5" height="5" rx="2.5"/>
				<rect x="767" y="144" width="5" height="5" rx="2.5"/>
				<rect x="783" y="144" width="5" height="5" rx="2.5"/>
				<rect x="799" y="144" width="5" height="5" rx="2.5"/>
				<rect x="815" y="144" width="5" height="5" rx="2.5"/>
				<rect x="831" y="144" width="5" height="5" rx="2.5"/>
				<rect x="847" y="144" width="5" height="5" rx="2.5"/>
				<rect x="863" y="144" width="5" height="5" rx="2.5"/>
				<rect x="879" y="144" width="5" height="5" rx="2.5"/>
				<rect x="895" y="144" width="5" height="5" rx="2.5"/>
				<rect x="911" y="144" width="5" height="5" rx="2.5"/>
				<rect x="927" y="144" width="5" height="5" rx="2.5"/>
				<rect x="943" y="144" width="5" height="5" rx="2.5"/>
				<rect x="959" y="144" width="5" height="5" rx="2.5"/>
				<rect x="975" y="144" width="5" height="5" rx="2.5"/>
				<rect x="991" y="144" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="144" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="144" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="144" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="144" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="144" width="5" height="5" rx="2.5"/>
				<rect x="1119" y="144" width="5" height="5" rx="2.5"/>
				<rect x="1135" y="144" width="5" height="5" rx="2.5"/>
				<rect x="31" y="128" width="5" height="5" rx="2.5"/>
				<rect x="47" y="128" width="5" height="5" rx="2.5"/>
				<rect x="111" y="128" width="5" height="5" rx="2.5"/>
				<rect x="127" y="128" width="5" height="5" rx="2.5"/>
				<rect x="143" y="128" width="5" height="5" rx="2.5"/>
				<rect x="159" y="128" width="5" height="5" rx="2.5"/>
				<rect x="175" y="128" width="5" height="5" rx="2.5"/>
				<rect x="191" y="128" width="5" height="5" rx="2.5"/>
				<rect x="207" y="128" width="5" height="5" rx="2.5"/>
				<rect x="223" y="128" width="5" height="5" rx="2.5"/>
				<rect x="239" y="128" width="5" height="5" rx="2.5"/>
				<rect x="255" y="128" width="5" height="5" rx="2.5"/>
				<rect x="319" y="128" width="5" height="5" rx="2.5"/>
				<rect x="335" y="128" width="5" height="5" rx="2.5"/>
				<rect x="351" y="128" width="5" height="5" rx="2.5"/>
				<rect x="367" y="128" width="5" height="5" rx="2.5"/>
				<rect x="399" y="16" width="5" height="5" rx="2.5"/>
				<rect x="415" y="16" width="5" height="5" rx="2.5"/>
				<rect x="431" y="16" width="5" height="5" rx="2.5"/>
				<rect x="447" y="16" width="5" height="5" rx="2.5"/>
				<rect x="463" y="16" width="5" height="5" rx="2.5"/>
				<rect x="479" y="16" width="5" height="5" rx="2.5"/>
				<rect x="575" y="128" width="5" height="5" rx="2.5"/>
				<rect x="607" y="128" width="5" height="5" rx="2.5"/>
				<rect x="623" y="128" width="5" height="5" rx="2.5"/>
				<rect x="671" y="128" width="5" height="5" rx="2.5"/>
				<rect x="687" y="128" width="5" height="5" rx="2.5"/>
				<rect x="703" y="128" width="5" height="5" rx="2.5"/>
				<rect x="719" y="128" width="5" height="5" rx="2.5"/>
				<rect x="735" y="128" width="5" height="5" rx="2.5"/>
				<rect x="751" y="128" width="5" height="5" rx="2.5"/>
				<rect x="767" y="128" width="5" height="5" rx="2.5"/>
				<rect x="783" y="128" width="5" height="5" rx="2.5"/>
				<rect x="799" y="128" width="5" height="5" rx="2.5"/>
				<rect x="815" y="128" width="5" height="5" rx="2.5"/>
				<rect x="831" y="128" width="5" height="5" rx="2.5"/>
				<rect x="847" y="128" width="5" height="5" rx="2.5"/>
				<rect x="863" y="128" width="5" height="5" rx="2.5"/>
				<rect x="879" y="128" width="5" height="5" rx="2.5"/>
				<rect x="895" y="128" width="5" height="5" rx="2.5"/>
				<rect x="911" y="128" width="5" height="5" rx="2.5"/>
				<rect x="927" y="128" width="5" height="5" rx="2.5"/>
				<rect x="943" y="128" width="5" height="5" rx="2.5"/>
				<rect x="959" y="128" width="5" height="5" rx="2.5"/>
				<rect x="975" y="128" width="5" height="5" rx="2.5"/>
				<rect x="991" y="128" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="128" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="128" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="128" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="128" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="128" width="5" height="5" rx="2.5"/>
				<rect x="1135" y="128" width="5" height="5" rx="2.5"/>
				<rect x="15" y="112" width="5" height="5" rx="2.5"/>
				<rect x="31" y="112" width="5" height="5" rx="2.5"/>
				<rect x="47" y="112" width="5" height="5" rx="2.5"/>
				<rect x="63" y="112" width="5" height="5" rx="2.5"/>
				<rect x="79" y="112" width="5" height="5" rx="2.5"/>
				<rect x="95" y="112" width="5" height="5" rx="2.5"/>
				<rect x="111" y="112" width="5" height="5" rx="2.5"/>
				<rect x="127" y="112" width="5" height="5" rx="2.5"/>
				<rect x="143" y="112" width="5" height="5" rx="2.5"/>
				<rect x="159" y="112" width="5" height="5" rx="2.5"/>
				<rect x="175" y="112" width="5" height="5" rx="2.5"/>
				<rect x="191" y="112" width="5" height="5" rx="2.5"/>
				<rect x="207" y="112" width="5" height="5" rx="2.5"/>
				<rect x="223" y="112" width="5" height="5" rx="2.5"/>
				<rect x="239" y="112" width="5" height="5" rx="2.5"/>
				<rect x="255" y="112" width="5" height="5" rx="2.5"/>
				<rect x="319" y="112" width="5" height="5" rx="2.5"/>
				<rect x="335" y="112" width="5" height="5" rx="2.5"/>
				<rect x="415" y="112" width="5" height="5" rx="2.5"/>
				<rect x="431" width="5" height="5" rx="2.5"/>
				<rect x="447" width="5" height="5" rx="2.5"/>
				<rect x="463" width="5" height="5" rx="2.5"/>
				<rect x="479" width="5" height="5" rx="2.5"/>
				<rect x="607" y="112" width="5" height="5" rx="2.5"/>
				<rect x="623" y="112" width="5" height="5" rx="2.5"/>
				<rect x="639" y="112" width="5" height="5" rx="2.5"/>
				<rect x="671" y="112" width="5" height="5" rx="2.5"/>
				<rect x="687" y="112" width="5" height="5" rx="2.5"/>
				<rect x="703" y="112" width="5" height="5" rx="2.5"/>
				<rect x="719" y="112" width="5" height="5" rx="2.5"/>
				<rect x="735" y="112" width="5" height="5" rx="2.5"/>
				<rect x="751" y="112" width="5" height="5" rx="2.5"/>
				<rect x="767" y="112" width="5" height="5" rx="2.5"/>
				<rect x="783" y="112" width="5" height="5" rx="2.5"/>
				<rect x="799" y="112" width="5" height="5" rx="2.5"/>
				<rect x="815" y="112" width="5" height="5" rx="2.5"/>
				<rect x="831" y="112" width="5" height="5" rx="2.5"/>
				<rect x="847" y="112" width="5" height="5" rx="2.5"/>
				<rect x="863" y="112" width="5" height="5" rx="2.5"/>
				<rect x="879" y="112" width="5" height="5" rx="2.5"/>
				<rect x="895" y="112" width="5" height="5" rx="2.5"/>
				<rect x="911" y="112" width="5" height="5" rx="2.5"/>
				<rect x="927" y="112" width="5" height="5" rx="2.5"/>
				<rect x="943" y="112" width="5" height="5" rx="2.5"/>
				<rect x="959" y="112" width="5" height="5" rx="2.5"/>
				<rect x="975" y="112" width="5" height="5" rx="2.5"/>
				<rect x="991" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1103" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1119" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1135" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1151" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1167" y="112" width="5" height="5" rx="2.5"/>
				<rect x="1183" y="112" width="5" height="5" rx="2.5"/>
				<rect x="255" y="304" width="5" height="5" rx="2.5"/>
				<rect x="271" y="304" width="5" height="5" rx="2.5"/>
				<rect x="287" y="320" width="5" height="5" rx="2.5"/>
				<rect x="287" y="304" width="5" height="5" rx="2.5"/>
				<rect x="335" y="320" width="5" height="5" rx="2.5"/>
				<rect x="351" y="320" width="5" height="5" rx="2.5"/>
				<rect x="367" y="320" width="5" height="5" rx="2.5"/>
				<rect x="527" y="320" width="5" height="5" rx="2.5"/>
				<rect x="527" y="304" width="5" height="5" rx="2.5"/>
				<rect x="543" y="320" width="5" height="5" rx="2.5"/>
				<rect x="543" y="304" width="5" height="5" rx="2.5"/>
				<rect x="559" y="320" width="5" height="5" rx="2.5"/>
				<rect x="559" y="304" width="5" height="5" rx="2.5"/>
				<rect x="575" y="320" width="5" height="5" rx="2.5"/>
				<rect x="575" y="304" width="5" height="5" rx="2.5"/>
				<rect x="591" y="320" width="5" height="5" rx="2.5"/>
				<rect x="591" y="304" width="5" height="5" rx="2.5"/>
				<rect x="607" y="320" width="5" height="5" rx="2.5"/>
				<rect x="607" y="304" width="5" height="5" rx="2.5"/>
				<rect x="623" y="320" width="5" height="5" rx="2.5"/>
				<rect x="623" y="304" width="5" height="5" rx="2.5"/>
				<rect x="639" y="320" width="5" height="5" rx="2.5"/>
				<rect x="639" y="304" width="5" height="5" rx="2.5"/>
				<rect x="655" y="320" width="5" height="5" rx="2.5"/>
				<rect x="655" y="304" width="5" height="5" rx="2.5"/>
				<rect x="671" y="320" width="5" height="5" rx="2.5"/>
				<rect x="671" y="304" width="5" height="5" rx="2.5"/>
				<rect x="687" y="320" width="5" height="5" rx="2.5"/>
				<rect x="687" y="304" width="5" height="5" rx="2.5"/>
				<rect x="703" y="320" width="5" height="5" rx="2.5"/>
				<rect x="703" y="304" width="5" height="5" rx="2.5"/>
				<rect x="719" y="320" width="5" height="5" rx="2.5"/>
				<rect x="719" y="304" width="5" height="5" rx="2.5"/>
				<rect x="735" y="320" width="5" height="5" rx="2.5"/>
				<rect x="735" y="304" width="5" height="5" rx="2.5"/>
				<rect x="751" y="320" width="5" height="5" rx="2.5"/>
				<rect x="751" y="304" width="5" height="5" rx="2.5"/>
				<rect x="847" y="320" width="5" height="5" rx="2.5"/>
				<rect x="847" y="304" width="5" height="5" rx="2.5"/>
				<rect x="863" y="320" width="5" height="5" rx="2.5"/>
				<rect x="863" y="304" width="5" height="5" rx="2.5"/>
				<rect x="911" y="304" width="5" height="5" rx="2.5"/>
				<rect x="927" y="320" width="5" height="5" rx="2.5"/>
				<rect x="927" y="304" width="5" height="5" rx="2.5"/>
				<rect x="943" y="320" width="5" height="5" rx="2.5"/>
				<rect x="943" y="304" width="5" height="5" rx="2.5"/>
				<rect x="959" y="320" width="5" height="5" rx="2.5"/>
				<rect x="959" y="304" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="304" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="320" width="5" height="5" rx="2.5"/>
				<rect x="223" y="288" width="5" height="5" rx="2.5"/>
				<rect x="239" y="288" width="5" height="5" rx="2.5"/>
				<rect x="255" y="288" width="5" height="5" rx="2.5"/>
				<rect x="271" y="288" width="5" height="5" rx="2.5"/>
				<rect x="319" y="288" width="5" height="5" rx="2.5"/>
				<rect x="335" y="288" width="5" height="5" rx="2.5"/>
				<rect x="527" y="288" width="5" height="5" rx="2.5"/>
				<rect x="543" y="288" width="5" height="5" rx="2.5"/>
				<rect x="559" y="288" width="5" height="5" rx="2.5"/>
				<rect x="575" y="288" width="5" height="5" rx="2.5"/>
				<rect x="591" y="288" width="5" height="5" rx="2.5"/>
				<rect x="607" y="288" width="5" height="5" rx="2.5"/>
				<rect x="623" y="288" width="5" height="5" rx="2.5"/>
				<rect x="639" y="288" width="5" height="5" rx="2.5"/>
				<rect x="655" y="288" width="5" height="5" rx="2.5"/>
				<rect x="671" y="288" width="5" height="5" rx="2.5"/>
				<rect x="687" y="288" width="5" height="5" rx="2.5"/>
				<rect x="703" y="288" width="5" height="5" rx="2.5"/>
				<rect x="735" y="288" width="5" height="5" rx="2.5"/>
				<rect x="751" y="288" width="5" height="5" rx="2.5"/>
				<rect x="767" y="288" width="5" height="5" rx="2.5"/>
				<rect x="783" y="288" width="5" height="5" rx="2.5"/>
				<rect x="831" y="288" width="5" height="5" rx="2.5"/>
				<rect x="847" y="288" width="5" height="5" rx="2.5"/>
				<rect x="863" y="288" width="5" height="5" rx="2.5"/>
				<rect x="879" y="288" width="5" height="5" rx="2.5"/>
				<rect x="911" y="288" width="5" height="5" rx="2.5"/>
				<rect x="927" y="288" width="5" height="5" rx="2.5"/>
				<rect x="943" y="288" width="5" height="5" rx="2.5"/>
				<rect x="223" y="272" width="5" height="5" rx="2.5"/>
				<rect x="239" y="272" width="5" height="5" rx="2.5"/>
				<rect x="319" y="272" width="5" height="5" rx="2.5"/>
				<rect x="527" y="272" width="5" height="5" rx="2.5"/>
				<rect x="543" y="272" width="5" height="5" rx="2.5"/>
				<rect x="559" y="272" width="5" height="5" rx="2.5"/>
				<rect x="575" y="272" width="5" height="5" rx="2.5"/>
				<rect x="591" y="272" width="5" height="5" rx="2.5"/>
				<rect x="607" y="272" width="5" height="5" rx="2.5"/>
				<rect x="623" y="272" width="5" height="5" rx="2.5"/>
				<rect x="639" y="272" width="5" height="5" rx="2.5"/>
				<rect x="655" y="272" width="5" height="5" rx="2.5"/>
				<rect x="671" y="272" width="5" height="5" rx="2.5"/>
				<rect x="687" y="272" width="5" height="5" rx="2.5"/>
				<rect x="703" y="272" width="5" height="5" rx="2.5"/>
				<rect x="719" y="272" width="5" height="5" rx="2.5"/>
				<rect x="735" y="272" width="5" height="5" rx="2.5"/>
				<rect x="751" y="272" width="5" height="5" rx="2.5"/>
				<rect x="767" y="272" width="5" height="5" rx="2.5"/>
				<rect x="783" y="272" width="5" height="5" rx="2.5"/>
				<rect x="831" y="272" width="5" height="5" rx="2.5"/>
				<rect x="847" y="272" width="5" height="5" rx="2.5"/>
				<rect x="879" y="272" width="5" height="5" rx="2.5"/>
				<rect x="895" y="272" width="5" height="5" rx="2.5"/>
				<rect x="911" y="272" width="5" height="5" rx="2.5"/>
				<rect x="927" y="272" width="5" height="5" rx="2.5"/>
				<rect x="943" y="272" width="5" height="5" rx="2.5"/>
				<rect x="959" y="272" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="272" width="5" height="5" rx="2.5"/>
				<rect x="207" y="256" width="5" height="5" rx="2.5"/>
				<rect x="223" y="256" width="5" height="5" rx="2.5"/>
				<rect x="239" y="256" width="5" height="5" rx="2.5"/>
				<rect x="543" y="256" width="5" height="5" rx="2.5"/>
				<rect x="559" y="256" width="5" height="5" rx="2.5"/>
				<rect x="575" y="256" width="5" height="5" rx="2.5"/>
				<rect x="591" y="256" width="5" height="5" rx="2.5"/>
				<rect x="607" y="256" width="5" height="5" rx="2.5"/>
				<rect x="623" y="256" width="5" height="5" rx="2.5"/>
				<rect x="639" y="256" width="5" height="5" rx="2.5"/>
				<rect x="655" y="256" width="5" height="5" rx="2.5"/>
				<rect x="671" y="256" width="5" height="5" rx="2.5"/>
				<rect x="687" y="256" width="5" height="5" rx="2.5"/>
				<rect x="703" y="256" width="5" height="5" rx="2.5"/>
				<rect x="719" y="256" width="5" height="5" rx="2.5"/>
				<rect x="735" y="256" width="5" height="5" rx="2.5"/>
				<rect x="751" y="256" width="5" height="5" rx="2.5"/>
				<rect x="783" y="256" width="5" height="5" rx="2.5"/>
				<rect x="799" y="256" width="5" height="5" rx="2.5"/>
				<rect x="815" y="256" width="5" height="5" rx="2.5"/>
				<rect x="831" y="256" width="5" height="5" rx="2.5"/>
				<rect x="847" y="256" width="5" height="5" rx="2.5"/>
				<rect x="863" y="256" width="5" height="5" rx="2.5"/>
				<rect x="879" y="256" width="5" height="5" rx="2.5"/>
				<rect x="895" y="256" width="5" height="5" rx="2.5"/>
				<rect x="911" y="256" width="5" height="5" rx="2.5"/>
				<rect x="927" y="256" width="5" height="5" rx="2.5"/>
				<rect x="943" y="256" width="5" height="5" rx="2.5"/>
				<rect x="959" y="256" width="5" height="5" rx="2.5"/>
				<rect x="975" y="256" width="5" height="5" rx="2.5"/>
				<rect x="991" y="256" width="5" height="5" rx="2.5"/>
				<rect x="191" y="240" width="5" height="5" rx="2.5"/>
				<rect x="207" y="240" width="5" height="5" rx="2.5"/>
				<rect x="223" y="240" width="5" height="5" rx="2.5"/>
				<rect x="239" y="240" width="5" height="5" rx="2.5"/>
				<rect x="255" y="240" width="5" height="5" rx="2.5"/>
				<rect x="271" y="240" width="5" height="5" rx="2.5"/>
				<rect x="287" y="240" width="5" height="5" rx="2.5"/>
				<rect x="303" y="240" width="5" height="5" rx="2.5"/>
				<rect x="559" y="240" width="5" height="5" rx="2.5"/>
				<rect x="575" y="240" width="5" height="5" rx="2.5"/>
				<rect x="591" y="240" width="5" height="5" rx="2.5"/>
				<rect x="607" y="240" width="5" height="5" rx="2.5"/>
				<rect x="623" y="240" width="5" height="5" rx="2.5"/>
				<rect x="639" y="240" width="5" height="5" rx="2.5"/>
				<rect x="655" y="240" width="5" height="5" rx="2.5"/>
				<rect x="671" y="240" width="5" height="5" rx="2.5"/>
				<rect x="687" y="240" width="5" height="5" rx="2.5"/>
				<rect x="703" y="240" width="5" height="5" rx="2.5"/>
				<rect x="719" y="240" width="5" height="5" rx="2.5"/>
				<rect x="735" y="240" width="5" height="5" rx="2.5"/>
				<rect x="751" y="240" width="5" height="5" rx="2.5"/>
				<rect x="767" y="240" width="5" height="5" rx="2.5"/>
				<rect x="783" y="240" width="5" height="5" rx="2.5"/>
				<rect x="799" y="240" width="5" height="5" rx="2.5"/>
				<rect x="815" y="240" width="5" height="5" rx="2.5"/>
				<rect x="831" y="240" width="5" height="5" rx="2.5"/>
				<rect x="847" y="240" width="5" height="5" rx="2.5"/>
				<rect x="863" y="240" width="5" height="5" rx="2.5"/>
				<rect x="879" y="240" width="5" height="5" rx="2.5"/>
				<rect x="895" y="240" width="5" height="5" rx="2.5"/>
				<rect x="911" y="240" width="5" height="5" rx="2.5"/>
				<rect x="927" y="240" width="5" height="5" rx="2.5"/>
				<rect x="943" y="240" width="5" height="5" rx="2.5"/>
				<rect x="959" y="240" width="5" height="5" rx="2.5"/>
				<rect x="975" y="240" width="5" height="5" rx="2.5"/>
				<rect x="175" y="224" width="5" height="5" rx="2.5"/>
				<rect x="191" y="224" width="5" height="5" rx="2.5"/>
				<rect x="207" y="224" width="5" height="5" rx="2.5"/>
				<rect x="223" y="224" width="5" height="5" rx="2.5"/>
				<rect x="239" y="224" width="5" height="5" rx="2.5"/>
				<rect x="255" y="224" width="5" height="5" rx="2.5"/>
				<rect x="271" y="224" width="5" height="5" rx="2.5"/>
				<rect x="287" y="224" width="5" height="5" rx="2.5"/>
				<rect x="303" y="224" width="5" height="5" rx="2.5"/>
				<rect x="319" y="224" width="5" height="5" rx="2.5"/>
				<rect x="575" y="224" width="5" height="5" rx="2.5"/>
				<rect x="591" y="224" width="5" height="5" rx="2.5"/>
				<rect x="607" y="224" width="5" height="5" rx="2.5"/>
				<rect x="719" y="224" width="5" height="5" rx="2.5"/>
				<rect x="735" y="224" width="5" height="5" rx="2.5"/>
				<rect x="751" y="224" width="5" height="5" rx="2.5"/>
				<rect x="767" y="224" width="5" height="5" rx="2.5"/>
				<rect x="783" y="224" width="5" height="5" rx="2.5"/>
				<rect x="799" y="224" width="5" height="5" rx="2.5"/>
				<rect x="815" y="224" width="5" height="5" rx="2.5"/>
				<rect x="831" y="224" width="5" height="5" rx="2.5"/>
				<rect x="847" y="224" width="5" height="5" rx="2.5"/>
				<rect x="863" y="224" width="5" height="5" rx="2.5"/>
				<rect x="879" y="224" width="5" height="5" rx="2.5"/>
				<rect x="895" y="224" width="5" height="5" rx="2.5"/>
				<rect x="911" y="224" width="5" height="5" rx="2.5"/>
				<rect x="927" y="224" width="5" height="5" rx="2.5"/>
				<rect x="943" y="224" width="5" height="5" rx="2.5"/>
				<rect x="959" y="224" width="5" height="5" rx="2.5"/>
				<rect x="975" y="224" width="5" height="5" rx="2.5"/>
				<rect x="991" y="224" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="224" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="224" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="224" width="5" height="5" rx="2.5"/>
				<rect x="319" y="416" width="5" height="5" rx="2.5"/>
				<rect x="335" y="432" width="5" height="5" rx="2.5"/>
				<rect x="335" y="416" width="5" height="5" rx="2.5"/>
				<rect x="351" y="432" width="5" height="5" rx="2.5"/>
				<rect x="351" y="416" width="5" height="5" rx="2.5"/>
				<rect x="367" y="432" width="5" height="5" rx="2.5"/>
				<rect x="367" y="416" width="5" height="5" rx="2.5"/>
				<rect x="383" y="432" width="5" height="5" rx="2.5"/>
				<rect x="383" y="416" width="5" height="5" rx="2.5"/>
				<rect x="399" y="432" width="5" height="5" rx="2.5"/>
				<rect x="399" y="416" width="5" height="5" rx="2.5"/>
				<rect x="415" y="432" width="5" height="5" rx="2.5"/>
				<rect x="415" y="416" width="5" height="5" rx="2.5"/>
				<rect x="431" y="432" width="5" height="5" rx="2.5"/>
				<rect x="431" y="416" width="5" height="5" rx="2.5"/>
				<rect x="447" y="432" width="5" height="5" rx="2.5"/>
				<rect x="447" y="416" width="5" height="5" rx="2.5"/>
				<rect x="623" y="432" width="5" height="5" rx="2.5"/>
				<rect x="639" y="432" width="5" height="5" rx="2.5"/>
				<rect x="639" y="416" width="5" height="5" rx="2.5"/>
				<rect x="655" y="432" width="5" height="5" rx="2.5"/>
				<rect x="655" y="416" width="5" height="5" rx="2.5"/>
				<rect x="671" y="432" width="5" height="5" rx="2.5"/>
				<rect x="671" y="416" width="5" height="5" rx="2.5"/>
				<rect x="687" y="432" width="5" height="5" rx="2.5"/>
				<rect x="687" y="416" width="5" height="5" rx="2.5"/>
				<rect x="703" y="432" width="5" height="5" rx="2.5"/>
				<rect x="703" y="416" width="5" height="5" rx="2.5"/>
				<rect x="719" y="432" width="5" height="5" rx="2.5"/>
				<rect x="719" y="416" width="5" height="5" rx="2.5"/>
				<rect x="751" y="432" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="432" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="432" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="432" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="416" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="432" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="432" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="416" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="432" width="5" height="5" rx="2.5"/>
				<rect x="319" y="400" width="5" height="5" rx="2.5"/>
				<rect x="335" y="400" width="5" height="5" rx="2.5"/>
				<rect x="351" y="400" width="5" height="5" rx="2.5"/>
				<rect x="367" y="400" width="5" height="5" rx="2.5"/>
				<rect x="383" y="400" width="5" height="5" rx="2.5"/>
				<rect x="399" y="400" width="5" height="5" rx="2.5"/>
				<rect x="415" y="400" width="5" height="5" rx="2.5"/>
				<rect x="431" y="400" width="5" height="5" rx="2.5"/>
				<rect x="447" y="400" width="5" height="5" rx="2.5"/>
				<rect x="463" y="400" width="5" height="5" rx="2.5"/>
				<rect x="639" y="400" width="5" height="5" rx="2.5"/>
				<rect x="655" y="400" width="5" height="5" rx="2.5"/>
				<rect x="671" y="400" width="5" height="5" rx="2.5"/>
				<rect x="687" y="400" width="5" height="5" rx="2.5"/>
				<rect x="703" y="400" width="5" height="5" rx="2.5"/>
				<rect x="719" y="400" width="5" height="5" rx="2.5"/>
				<rect x="959" y="400" width="5" height="5" rx="2.5"/>
				<rect x="975" y="400" width="5" height="5" rx="2.5"/>
				<rect x="991" y="400" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="400" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="400" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="400" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="400" width="5" height="5" rx="2.5"/>
				<rect x="303" y="384" width="5" height="5" rx="2.5"/>
				<rect x="319" y="384" width="5" height="5" rx="2.5"/>
				<rect x="335" y="384" width="5" height="5" rx="2.5"/>
				<rect x="351" y="384" width="5" height="5" rx="2.5"/>
				<rect x="367" y="384" width="5" height="5" rx="2.5"/>
				<rect x="383" y="384" width="5" height="5" rx="2.5"/>
				<rect x="399" y="384" width="5" height="5" rx="2.5"/>
				<rect x="415" y="384" width="5" height="5" rx="2.5"/>
				<rect x="431" y="384" width="5" height="5" rx="2.5"/>
				<rect x="447" y="384" width="5" height="5" rx="2.5"/>
				<rect x="623" y="384" width="5" height="5" rx="2.5"/>
				<rect x="639" y="384" width="5" height="5" rx="2.5"/>
				<rect x="655" y="384" width="5" height="5" rx="2.5"/>
				<rect x="671" y="384" width="5" height="5" rx="2.5"/>
				<rect x="687" y="384" width="5" height="5" rx="2.5"/>
				<rect x="703" y="384" width="5" height="5" rx="2.5"/>
				<rect x="719" y="384" width="5" height="5" rx="2.5"/>
				<rect x="927" y="384" width="5" height="5" rx="2.5"/>
				<rect x="943" y="384" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="384" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="384" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="384" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="384" width="5" height="5" rx="2.5"/>
				<rect x="303" y="368" width="5" height="5" rx="2.5"/>
				<rect x="319" y="368" width="5" height="5" rx="2.5"/>
				<rect x="335" y="368" width="5" height="5" rx="2.5"/>
				<rect x="351" y="368" width="5" height="5" rx="2.5"/>
				<rect x="367" y="368" width="5" height="5" rx="2.5"/>
				<rect x="383" y="368" width="5" height="5" rx="2.5"/>
				<rect x="399" y="368" width="5" height="5" rx="2.5"/>
				<rect x="415" y="368" width="5" height="5" rx="2.5"/>
				<rect x="623" y="368" width="5" height="5" rx="2.5"/>
				<rect x="639" y="368" width="5" height="5" rx="2.5"/>
				<rect x="655" y="368" width="5" height="5" rx="2.5"/>
				<rect x="671" y="368" width="5" height="5" rx="2.5"/>
				<rect x="687" y="368" width="5" height="5" rx="2.5"/>
				<rect x="703" y="368" width="5" height="5" rx="2.5"/>
				<rect x="719" y="368" width="5" height="5" rx="2.5"/>
				<rect x="927" y="368" width="5" height="5" rx="2.5"/>
				<rect x="959" y="368" width="5" height="5" rx="2.5"/>
				<rect x="975" y="368" width="5" height="5" rx="2.5"/>
				<rect x="991" y="368" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="368" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="368" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="368" width="5" height="5" rx="2.5"/>
				<rect x="319" y="352" width="5" height="5" rx="2.5"/>
				<rect x="335" y="352" width="5" height="5" rx="2.5"/>
				<rect x="351" y="352" width="5" height="5" rx="2.5"/>
				<rect x="367" y="352" width="5" height="5" rx="2.5"/>
				<rect x="383" y="352" width="5" height="5" rx="2.5"/>
				<rect x="399" y="352" width="5" height="5" rx="2.5"/>
				<rect x="623" y="352" width="5" height="5" rx="2.5"/>
				<rect x="639" y="352" width="5" height="5" rx="2.5"/>
				<rect x="655" y="352" width="5" height="5" rx="2.5"/>
				<rect x="671" y="352" width="5" height="5" rx="2.5"/>
				<rect x="687" y="352" width="5" height="5" rx="2.5"/>
				<rect x="703" y="352" width="5" height="5" rx="2.5"/>
				<rect x="719" y="352" width="5" height="5" rx="2.5"/>
				<rect x="735" y="352" width="5" height="5" rx="2.5"/>
				<rect x="911" y="352" width="5" height="5" rx="2.5"/>
				<rect x="943" y="352" width="5" height="5" rx="2.5"/>
				<rect x="975" y="352" width="5" height="5" rx="2.5"/>
				<rect x="991" y="352" width="5" height="5" rx="2.5"/>
				<rect x="303" y="336" width="5" height="5" rx="2.5"/>
				<rect x="319" y="336" width="5" height="5" rx="2.5"/>
				<rect x="335" y="336" width="5" height="5" rx="2.5"/>
				<rect x="351" y="336" width="5" height="5" rx="2.5"/>
				<rect x="367" y="336" width="5" height="5" rx="2.5"/>
				<rect x="383" y="336" width="5" height="5" rx="2.5"/>
				<rect x="543" y="336" width="5" height="5" rx="2.5"/>
				<rect x="559" y="336" width="5" height="5" rx="2.5"/>
				<rect x="575" y="336" width="5" height="5" rx="2.5"/>
				<rect x="591" y="336" width="5" height="5" rx="2.5"/>
				<rect x="607" y="336" width="5" height="5" rx="2.5"/>
				<rect x="623" y="336" width="5" height="5" rx="2.5"/>
				<rect x="639" y="336" width="5" height="5" rx="2.5"/>
				<rect x="655" y="336" width="5" height="5" rx="2.5"/>
				<rect x="671" y="336" width="5" height="5" rx="2.5"/>
				<rect x="687" y="336" width="5" height="5" rx="2.5"/>
				<rect x="703" y="336" width="5" height="5" rx="2.5"/>
				<rect x="719" y="336" width="5" height="5" rx="2.5"/>
				<rect x="735" y="336" width="5" height="5" rx="2.5"/>
				<rect x="751" y="336" width="5" height="5" rx="2.5"/>
				<rect x="847" y="336" width="5" height="5" rx="2.5"/>
				<rect x="927" y="336" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="336" width="5" height="5" rx="2.5"/>
				<rect x="335" y="544" width="5" height="5" rx="2.5"/>
				<rect x="335" y="528" width="5" height="5" rx="2.5"/>
				<rect x="351" y="544" width="5" height="5" rx="2.5"/>
				<rect x="351" y="528" width="5" height="5" rx="2.5"/>
				<rect x="367" y="528" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="544" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="528" width="5" height="5" rx="2.5"/>
				<rect x="1167" y="544" width="5" height="5" rx="2.5"/>
				<rect x="1183" y="544" width="5" height="5" rx="2.5"/>
				<rect x="1183" y="528" width="5" height="5" rx="2.5"/>
				<rect x="1199" y="528" width="5" height="5" rx="2.5"/>
				<rect x="335" y="512" width="5" height="5" rx="2.5"/>
				<rect x="351" y="512" width="5" height="5" rx="2.5"/>
				<rect x="367" y="512" width="5" height="5" rx="2.5"/>
				<rect x="383" y="512" width="5" height="5" rx="2.5"/>
				<rect x="991" y="512" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="512" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="512" width="5" height="5" rx="2.5"/>
				<rect x="1103" y="512" width="5" height="5" rx="2.5"/>
				<rect x="351" y="496" width="5" height="5" rx="2.5"/>
				<rect x="367" y="496" width="5" height="5" rx="2.5"/>
				<rect x="383" y="496" width="5" height="5" rx="2.5"/>
				<rect x="399" y="496" width="5" height="5" rx="2.5"/>
				<rect x="655" y="496" width="5" height="5" rx="2.5"/>
				<rect x="671" y="496" width="5" height="5" rx="2.5"/>
				<rect x="991" y="496" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="496" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="496" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="496" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="496" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="496" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="496" width="5" height="5" rx="2.5"/>
				<rect x="351" y="480" width="5" height="5" rx="2.5"/>
				<rect x="367" y="480" width="5" height="5" rx="2.5"/>
				<rect x="383" y="480" width="5" height="5" rx="2.5"/>
				<rect x="399" y="480" width="5" height="5" rx="2.5"/>
				<rect x="415" y="480" width="5" height="5" rx="2.5"/>
				<rect x="639" y="480" width="5" height="5" rx="2.5"/>
				<rect x="655" y="480" width="5" height="5" rx="2.5"/>
				<rect x="671" y="480" width="5" height="5" rx="2.5"/>
				<rect x="687" y="480" width="5" height="5" rx="2.5"/>
				<rect x="991" y="480" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="480" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="480" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="480" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="480" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="480" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="480" width="5" height="5" rx="2.5"/>
				<rect x="1103" y="480" width="5" height="5" rx="2.5"/>
				<rect x="1119" y="480" width="5" height="5" rx="2.5"/>
				<rect x="351" y="464" width="5" height="5" rx="2.5"/>
				<rect x="367" y="464" width="5" height="5" rx="2.5"/>
				<rect x="383" y="464" width="5" height="5" rx="2.5"/>
				<rect x="399" y="464" width="5" height="5" rx="2.5"/>
				<rect x="415" y="464" width="5" height="5" rx="2.5"/>
				<rect x="639" y="464" width="5" height="5" rx="2.5"/>
				<rect x="655" y="464" width="5" height="5" rx="2.5"/>
				<rect x="671" y="464" width="5" height="5" rx="2.5"/>
				<rect x="687" y="464" width="5" height="5" rx="2.5"/>
				<rect x="735" y="464" width="5" height="5" rx="2.5"/>
				<rect x="975" y="464" width="5" height="5" rx="2.5"/>
				<rect x="991" y="464" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="464" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="464" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="464" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="464" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="464" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="464" width="5" height="5" rx="2.5"/>
				<rect x="351" y="448" width="5" height="5" rx="2.5"/>
				<rect x="367" y="448" width="5" height="5" rx="2.5"/>
				<rect x="383" y="448" width="5" height="5" rx="2.5"/>
				<rect x="399" y="448" width="5" height="5" rx="2.5"/>
				<rect x="415" y="448" width="5" height="5" rx="2.5"/>
				<rect x="431" y="448" width="5" height="5" rx="2.5"/>
				<rect x="447" y="448" width="5" height="5" rx="2.5"/>
				<rect x="639" y="448" width="5" height="5" rx="2.5"/>
				<rect x="655" y="448" width="5" height="5" rx="2.5"/>
				<rect x="671" y="448" width="5" height="5" rx="2.5"/>
				<rect x="687" y="448" width="5" height="5" rx="2.5"/>
				<rect x="703" y="448" width="5" height="5" rx="2.5"/>
				<rect x="735" y="448" width="5" height="5" rx="2.5"/>
				<rect x="751" y="448" width="5" height="5" rx="2.5"/>
				<rect x="991" y="448" width="5" height="5" rx="2.5"/>
				<rect x="1007" y="448" width="5" height="5" rx="2.5"/>
				<rect x="1023" y="448" width="5" height="5" rx="2.5"/>
				<rect x="1039" y="448" width="5" height="5" rx="2.5"/>
				<rect x="1055" y="448" width="5" height="5" rx="2.5"/>
				<rect x="1071" y="448" width="5" height="5" rx="2.5"/>
				<rect x="1087" y="448" width="5" height="5" rx="2.5"/>
				<rect x="1151" y="448" width="5" height="5" rx="2.5"/>
				<rect x="335" y="592" width="5" height="5" rx="2.5"/>
				<rect x="351" y="592" width="5" height="5" rx="2.5"/>
				<rect x="367" y="592" width="5" height="5" rx="2.5"/>
				<rect x="335" y="576" width="5" height="5" rx="2.5"/>
				<rect x="351" y="576" width="5" height="5" rx="2.5"/>
				<rect x="335" y="560" width="5" height="5" rx="2.5"/>
				<rect x="351" y="560" width="5" height="5" rx="2.5"/>
				<rect x="1167" y="560" width="5" height="5" rx="2.5"/>
			</g>
		</svg>
		<div className="globe__label" style="top:50%; left:50%; opacity:0;"></div>
	</div>
)


export const init = () => {
	const el = [...document.querySelectorAll('.globe')]
	el.map(setupEl)
}


const setupEl = (el) => {
	if (!el) return
	const label = el.querySelector('.globe__label')
	const hovers = [...el.querySelectorAll('.globe__hover')]
	hovers.forEach((hover) => {
		hover.addEventListener('mouseenter', (event) => {
			const title = event.currentTarget.getAttribute('data-title')
			const subtitle = event.currentTarget.getAttribute('data-subtitle')
			const x = parseInt(event.currentTarget.getAttribute('x'))
			const y = parseInt(event.currentTarget.getAttribute('y'))
			label.innerHTML = title
			label.style.left = `${x / svgWidth * 100 }%`
			label.style.top = `${y / svgHeight * 100 }%`
			label.style.opacity = 1
		})
	})
	hovers.map(
		hover => hover.addEventListener('mouseleave', () => {
			label.style.opacity = 0
		})
	)
}
